import { AssistantDetail } from '@/types/assistant'
import axios from '../request'

export interface AssistantItemDB {
  create_time: string
  desc: string
  id: string
  logo?: string
  name: string
  update_time: string
  user_id: number
  user_name: string
  status: number
}
// 获取助手列表
export const getAssistantsApi = async (
  page,
  limit,
  name,
  category_code,
  status,
  type = null
): Promise<AssistantItemDB[]> => {
  return await axios.get('/api/v1/assistant', {
    params: {
      page,
      limit,
      name,
      category_code,
      status,
      type
    }
  })
}

// 创建助手
export const createAssistantsApi = async (
  name,
  desc,
  logo,
  category_code,
  tool_ids = [],
  onlyChat = false,
  model_name = ''
) => {
  return await axios.post('/api/v1/assistant', {
    name,
    desc,
    logo,
    category_code,
    tool_ids,
    only_chat: onlyChat,
    model_name
  })
}

// 获取助手详情
export const getAssistantDetailApi = async (id): Promise<AssistantDetail> => {
  return await axios.get(`/api/v1/assistant/info/${id}`)
}

// 上报点击数据
export const collectEventApi = async data => {
  return await axios.post('/api/v1/assistant/collect_event', data)
}

// 查询点击数据
export const getCollectInfoApi = async (id): Promise<any> => {
  return await axios.get(`/api/v1/assistant/${id}/collect_info`)
}
// 获取mcp server 的工具列表
export const getToolsListApi = async (id): Promise<any> => {
  return await axios.get(`/api/v1/mcp_server/tools_list?server_id=${id}`)
}
// 查询mcp服务列表
export const getMcpServerApi = async (params): Promise<any> => {
  return await axios.get(`/api/v1/mcp_server/list`, { params })
}

// 获取助手系统模型
export const getAssistantModelsApi = async (company_id = null): Promise<any> => {
  return await axios.get('/api/v1/assistant/models' + `?company_id=${company_id}`)
}

// 获取模型列表
export const getModelManageListApi = async (enterprise_id = null, keyword = '', scene = ''): Promise<any> => {
  return await axios.get(
    '/api/v1/model_manage/list' + `?enterprise_id=${enterprise_id}&keyword=${keyword}&scene=${scene}`
  )
}

// 上下线助手
export const changeAssistantStatusApi = async (id, status) => {
  return await axios.post('/api/v1/assistant/status', { id, status })
}

// 保存助手
export const saveAssistanttApi = async (
  data: Omit<AssistantDetail, 'flow_list' | 'tool_list' | 'knowledge_list' | 'mcp_list'> & {
    flow_list: string[] | any
    tool_list: number[]
    mcp_list: number[]
    knowledge_list: number[]
  }
): Promise<any> => {
  return await axios.put('/api/v1/assistant', data)
}

// 删除助手
export const deleteAssistantApi = async id => {
  return await axios.post(`/api/v1/assistant/delete?assistant_id=${id}`)
}

// 获取会话选择列表
export const getChatOnlineApi = async () => {
  return await axios.get('/api/v1/chat/online')
}

// 获取插件集合
export const getPublished_list = async (is_preset, is_custom, categoryCode = '', is_published = null): Promise<any> => {
  const data = {
    is_preset,
    is_custom,
    page: 1,
    limit: 10000,
    category_code: categoryCode || null,
    is_published
  }

  return await axios.post('/api/v1/tools/tools_list', data)
}

export type conditionsParamsType = {
  id: string
  type: string
  user: string
  platform: string
  timeRange: [number, number]
}

// 查询数据应用看板信息
export const getAstDataBoardInfoApi = async (conditions: conditionsParamsType) => {
  return await axios.post('/api/v1/dashboard/board_info', conditions)
}

// 权限-列表-baiying
export const roleOrganization = async (name = '', filter_department = false) => {
  return await axios.get(`/api/v1/baiying_user/organization?name=${name}&filter_department=${filter_department}`)
}
// 消息通知-搜索人员
export const messageFilterFun = async (name = '') => {
  return await axios.get(`/api/v1/baiying_user/users?name=${name}`)
}
/* 权限分配-创建 */
export const retriverScopeCreate = async (data: any) => {
  return await axios.post('/api/v1/retriver_scope/create', data)
}
/* 权限分配-list */
export const retriverScopeList = async (assistant_id: string = '', knowledge_id?: string, type?: any) => {
  const params = new URLSearchParams()

  if (assistant_id) params.append('assistant_id', assistant_id)
  if (knowledge_id) params.append('knowledge_id', knowledge_id)
  params.append('type', type)

  return await axios.get(`/api/v1/retriver_scope/detail?${params.toString()}`)
}

export type SaveToWordParamsType = {
  name: string
  content: string
}
// 导出word
export const saveToWordApi = async (saveToWordParams: SaveToWordParamsType) => {
  return await axios.post('/api/v1/assistant/save_to_word', saveToWordParams)
}

// 上传企业云空间
export type uploadToLenovoCloudType = {
  sso_key?: string
  name: string
  content: string
}
export const uploadToLenovoCloudApi = async (params: uploadToLenovoCloudType) => {
  return await axios.post('/api/v1/assistant/upload_to_cloud', params)
}

// 获取应用分享链接
export const getShareUrlApi = async (assistant_id: string): Promise<string> => {
  return await axios.get('/api/v1/assistant/get_share_url', {
    params: { assistant_id }
  })
}

// 获取助手模板列表
export const getAssistantsTemplateApi = async (
  page,
  limit,
  name,
  category_code,
  status,
  type = null
): Promise<AssistantItemDB[]> => {
  return await axios.get('/api/v1/assistant/template_assistant', {
    // return await axios.get('/api/v1/assistant', {
    params: {
      page,
      limit,
      name,
      category_code,
      status,
      type
    }
  })
}
